<template>
  <el-container style="height: 100%;background-color: darkgrey;">
    <el-header
      style="background-color: black;justify-items: center;line-height: 50px;height: 50px;">三锦照明有限公司</el-header>
    <el-container>
      <el-aside width="200px" style="min-width: 200px;width: 12%;height: 100vh;background-color: black;">
        <el-menu default-active="2" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
          background-color="#545c64" :default-openeds="['1', '3']" text-color="#fff" active-text-color="#ffd04b"
          style="border: none;text-align: left;" router>
          <el-submenu index="1" v-if="user&&user.intlevel==0">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>人员权限</span>
            </template>
            <el-menu-item index="/backindex/backuser">用户信息</el-menu-item>
            <el-menu-item index="/backindex/backrole">角色信息</el-menu-item>
            <el-menu-item index="/backindex/vueEditor">
              权限信息
            </el-menu-item>
          </el-submenu>
          <el-submenu index="1" v-if="user&&user.intlevel<2">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>主页</span>
            </template>
            <el-menu-item index="/backindex/backHome">中心图</el-menu-item>
            <el-menu-item index="/backindex/backHomeVideo">轮播</el-menu-item>
          </el-submenu>
          <el-submenu index="1" v-if="user&&user.intlevel<3">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>产品</span>
            </template>
            <el-menu-item index="/backindex/backproducttype" v-if="user&&user.intlevel<2">产品类型</el-menu-item>
            <el-menu-item index="/backindex/backproductmaincode" v-if="user&&user.intlevel<2">产品系列</el-menu-item>
            <el-menu-item index="/backindex/backproduct">产品信息</el-menu-item>
            <el-menu-item index="/backindex/BackProductSort" v-if="user&&user.intlevel<2">产品排序</el-menu-item>
          </el-submenu>
          <el-submenu index="3" v-if="user&&user.intlevel<2">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>新闻</span>
            </template>
            <el-menu-item index="/backindex/backcomnews">公司新闻</el-menu-item>
            <el-menu-item index="/backindex/backinsnews">行业新闻</el-menu-item>
            <el-menu-item index="/backindex/backtecsup">技术支持</el-menu-item>
          </el-submenu>
          <el-submenu index="3" v-if="user&&user.intlevel<2">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>下载中心</span>
            </template>
            <el-menu-item index="/backindex/BackCertificate">证书</el-menu-item>
            <el-menu-item index="/backindex/BackAlbum">画册</el-menu-item>
            <el-menu-item index="/backindex/BackHandBook">说明书</el-menu-item>
          </el-submenu>
          <el-submenu index="3" v-if="user&&user.intlevel<2">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>关于我们</span>
            </template>
            <!-- <el-menu-item index="/backindex/BackAboutUs">三锦</el-menu-item> -->
            <el-menu-item index="/backindex/backAboutRecruit">招聘</el-menu-item>
            <el-menu-item index="/backindex/backuser">联系我们</el-menu-item>
            <el-menu-item index="/backindex/backuser">留言</el-menu-item>

          </el-submenu>
          <el-submenu index="1" v-if="user&&user.intlevel<2">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>S-Vlog</span>
            </template>
            <el-menu-item index="/backindex/backVlogType">Vlog类型</el-menu-item>
            <el-menu-item index="/backindex/backvlog">Vlog信息</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
  export default {
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      }
    },
    computed: {
      user() {
        var storUser = localStorage.getItem("token")
        if (storUser != null) {
          const storedUser = localStorage.getItem("token");

						var thisuser = JSON.parse(storedUser);
            return thisuser;
        }
        else{
          return null
        }
      },
    },
    watch: {
			// '$route'(to, from) {

      //   console.log('123',to.path)
      //   console.log('456',from.path)
      // }

		},
  };
</script>

<style scoped>
  ::v-deep .el-menu-item {
    padding-left: 50px;
  }
</style>